import { FC, forwardRef, ReactNode, RefObject, ForwardedRef } from 'react';
import { Switch, SwitchProps, FormControlLabel, SxProps, Theme } from '@mui/material';
import { Colors } from '../../../constants';
import { clsx } from '../../../utils';

export interface CoreSwitchProps extends SwitchProps {
	id?: string;
	label?: ReactNode;
	labelSx?: SxProps<Theme>;
	controlSx?: SxProps<Theme>;
	error?: boolean;
}

export const CoreSwitch = forwardRef<HTMLButtonElement, Omit<CoreSwitchProps, 'ref'>>((props, ref) => {
	const {
		id,
		label,
		labelSx = {
			fontSize: '16px',
			fontWeight: 500,
			lineHeight: '28px',
			color: Colors.white,
		},
		controlSx,
		error,
		...switchProps
	} = props;

	return (
		<FormControlLabel
			id={id}
			label={label}
			sx={clsx(
				{
					m: 0,
					gap: '8px',
				},
				labelSx,
				controlSx,
				{
					color: error ? Colors.error : Colors.white,
				}
			)}
			control={
				<Switch
					{...switchProps}
					sx={clsx(
						{
							p: 0,
							height: 16,
							width: 32,

							'& .MuiSwitch-switchBase': {
								'&.Mui-checked': {
									'& + .MuiSwitch-track': {
										backgroundColor: Colors.white,
										opacity: 1,
										border: 0,
									},
								},
							},

							'& .MuiSwitch-track': {
								backgroundColor: '#3D3D3D',
								opacity: 1,
							},

							'& .MuiButtonBase-root': {
								p: 0,
								top: (16 - 12) / 2,
								transform: 'translateX(2px)',

								'& .MuiSwitch-thumb': {
									height: 12,
									width: 12,
								},

								'&.Mui-checked': {
									transform: 'translateX(18px)',
									color: Colors.black,
								},
							},
						},
						switchProps.sx
					)}
					ref={ref}
				/>
			}
		/>
	);
});

CoreSwitch.displayName = 'CoreSwitch';
